import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type NotificationSearchResponseDTO, transformNotificationDTO } from "./dto";

export class NotificationsApiError extends Error {
  readonly status: number;
  readonly body: unknown;

  constructor(url: string, status: number, body: unknown) {
    super(`Could not fetch ${url}: ${status}`);
    this.name = "NotificationsApiError";
    this.status = status;
    this.body = body;
  }
}

export async function fetchNotifications() {
  const url = occUrl("/notifications/pagedata");

  const response = await occFetch(url);
  if (!response.ok) {
    throw new NotificationsApiError(url, response.status, await readResponseBody(response));
  }

  const dto = (await response.json()) as NotificationSearchResponseDTO;

  return {
    results: (dto.results ?? []).map(transformNotificationDTO),
    totalAmount: dto.pagination?.totalResults ?? 0,
  };
}

async function readResponseBody(response: Response): Promise<unknown> {
  const text = await response.text();
  if (!text) {
    return undefined;
  }
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
